module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAPFBMVEVtbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1e8opWAAAAE3RSTlMAGBkbJScoSUqttbbk5ufv8fLzL02fUgAAAHFJREFUeF7t1DEOgzAQBdGPg4GFGAxz/7umdrFaR0oTyVO/eqTZKkHVZilfxHFlGUdSUDowVZLCEo9AHcG3cC04lbWBroPSQPz4TzjggAMW3M4GbidO762BP7xZ30gnHhn7FLnXjmnpm/0iZbsJui3rA3DRT29VfNwwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/normal.png
// module id = cghv
// module chunks = 1